"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionGetObjectIsError = exports.FunctionCheckIsError = void 0;
const type_1 = require("../../../type");
const FunctionCheckIsError = (object, mode) => {
    if (!object)
        return;
    let error = mode === type_1.TYPE_ERROR_NORMAL
        ? {
            error: false,
            message: "",
            name: "",
        }
        : [];
    const keys = Object.keys(object);
    keys.forEach((key) => {
        var _a, _b, _c, _d, _e;
        if ((_a = object[key]) === null || _a === void 0 ? void 0 : _a.error) {
            if (mode === type_1.TYPE_ERROR_NORMAL) {
                error = {
                    error: true,
                    message: (_b = object[key]) === null || _b === void 0 ? void 0 : _b.message,
                    name: key,
                };
            }
            if (mode === type_1.TYPE_ERROR_ARRAY) {
                error.push({
                    error: true,
                    message: (_c = object[key]) === null || _c === void 0 ? void 0 : _c.message,
                    name: key,
                });
            }
            if (document) {
                (_d = document === null || document === void 0 ? void 0 : document.getElementById(key)) === null || _d === void 0 ? void 0 : _d.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        }
        else {
            if (((_e = object[key]) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                const arrayKeys = object[key];
                for (let i = 0; i < arrayKeys.length; i++) {
                    const arrayKey = arrayKeys[i];
                    const thisKey = Object === null || Object === void 0 ? void 0 : Object.keys(arrayKey);
                    for (let j = 0; j < thisKey.length; j++) {
                        const thisStep = arrayKey[thisKey[j]];
                        if (thisStep === null || thisStep === void 0 ? void 0 : thisStep.error) {
                            if (mode === type_1.TYPE_ERROR_NORMAL) {
                                error = {
                                    error: true,
                                    message: thisStep === null || thisStep === void 0 ? void 0 : thisStep.message,
                                    name: `thisStep.field_name-${key}[${i}]-${thisKey[j]}`,
                                };
                            }
                            if (mode === type_1.TYPE_ERROR_ARRAY) {
                                error.push({
                                    error: true,
                                    message: thisStep === null || thisStep === void 0 ? void 0 : thisStep.message,
                                    name: `thisStep.field_name-${key}[${i}]-${thisKey[j]}`,
                                });
                            }
                            if (document) {
                                document.getElementById(thisStep.field_name).scrollIntoView({
                                    behavior: "smooth",
                                    block: "center",
                                });
                            }
                        }
                    }
                }
            }
        }
    });
    return error;
};
exports.FunctionCheckIsError = FunctionCheckIsError;
const FunctionGetObjectIsError = (data = {}) => {
    if (Object.keys(data).length > 0) {
        let errorState = [];
        const ObjectValues = Object.values(data);
        ObjectValues.forEach((item) => {
            const isArray = Array.isArray(item);
            if (isArray && item.length > 0) {
                item.forEach((arrayItem) => {
                    const ObjectValuesArray = Object.values(arrayItem);
                    ObjectValuesArray.forEach((arrayItemValue) => {
                        if (arrayItemValue === null || arrayItemValue === void 0 ? void 0 : arrayItemValue.error) {
                            errorState.push(arrayItemValue);
                        }
                    });
                });
            }
            else if (item === null || item === void 0 ? void 0 : item.error) {
                errorState.push(item);
            }
            else {
                return;
            }
            return item;
        });
        return errorState;
    }
    else {
        return;
    }
};
exports.FunctionGetObjectIsError = FunctionGetObjectIsError;
